class UnknownReportTypeError extends Error {
  constructor (message) {
    super(message);
    this.name = 'UnknownReportTypeError';
  }
}

export default UnknownReportTypeError;
